import React, { FC } from "react";
import ActiveFilters from "./components/ActiveFilters";
import FiltersActions from "./components/FiltersActions";
import FiltersProvider from "./context/FiltersProvider";
import { AppliedFilters } from "./types";
import "./filters.css";

type Props = {
  filters: AppliedFilters;
  onFiltersApply: (filters) => void;
};

const Filters: FC<Props> = ({ filters, children, onFiltersApply }) => {
  return (
    <FiltersProvider initialFilters={filters} onFiltersApply={onFiltersApply}>
      <div className="stats-filters">
        <div className="filters-applied">
          <ActiveFilters />
        </div>
        <div className="filter-selection">
          {children}
          <FiltersActions />
        </div>
      </div>
    </FiltersProvider>
  );
};

export default Filters;
